module.exports = __webpack_public_path__ + "img/office1.9f7bacd1.jpg";